<template>
  <ToolsHub />
</template>

<script>
import ToolsHub from '@/components/ToolsComar.vue'
export default { name: 'HomePage', components: { ToolsHub } }
</script>
